import React, { Component } from "react";

import authenticationService from "../services/AuthenticationService";
import userService from "../services/UserService";
import { withRouter } from "react-router-dom";
import AuthenticationService from "../services/AuthenticationService";
import { ReactComponent as PartnerLab } from "../assets/img/ico-partner-lab.svg";
import { setEmbeddedFromLocalStorage } from "../util/utils";
import { MY_PARDINI_URL } from "../constants";
class AppBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      client: null,
      clientList: [],
      menuOpen: false,
      loading: false,
    };
  }

  componentDidMount() {
    let userData = userService.getUserData();
    if (userData) {
      let user = {
        name: userData.userName ? userData.userName : null,
      };

      let client = {
        name: userService.getClientName() || null,
        type: userService.getUserType() || null,
      };
      this.setState({ user, client });
    }

    if (userData.relatedClients) {
      this.setState({
        clientList: userData.relatedClients,
      });
    }
  }
  async logOut(e) {
    e.preventDefault();
    setEmbeddedFromLocalStorage(false);
    this.setState({ loading: true });
    let logOut = await authenticationService.logout();
    this.setState({ loading: false });
    if (logOut) {
      this.props.history.replace("/login");
      console.info("user log out.");
    } else {
      console.error("Failed to log user out: Server denied.");
    }
  }

  async alterClient(client) {
    if (userService.getClientId() === client.code) {
      console.error(
        "Failed to switch Clients: The requested client is already the selected one."
      );
      return false;
    }

    const auth = await AuthenticationService.setUserClient(
      client.code,
      client.name
    );

    if (!auth.status) {
      console.error("Failed to switch Clients: Server denied.");
      return false;
    }

    const currentUser = userService.getCurrentUserClient();

    this.setState({
      client: currentUser,
    });

    this.props.history.replace("/");

    return true;
  }

  closeDropDown() {
    let menu = document.querySelector(".dropdown-menu");
    if (menu.classList.contains("user-type-menu")) {
      menu.classList.remove("user-type-menu");
    }
  }

  openDropDown() {
    let menu = document.querySelector("#dropdown-menu-labs");
    if (!menu.classList.contains("user-type-menu")) {
      menu.classList.add("user-type-menu");
    }
  }

  async toggleAlterLab(client) {
    let alterResult = await this.alterClient(client);

    if (!alterResult) {
      let active = document.getElementById(client.code);

      let menu = document.getElementById("dropdown-menu-labs");
      let options = menu.getElementsByClassName("dropdown-item");

      for (var c = 0; c < options.length; c++) {
        if (options[c].classList.contains("active")) {
          options[c].classList.remove("active");
        }
      }

      active.classList.add("active");
    }
    this.closeDropDown();
  }

  renderDropBox() {
    const styleDropbox = {
      margin: "0",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      minHeight: "50px",
      textAlign: "end",
      backgroundColor: "transparent",
    };

    return (
      <div className="dropdown dropdown-navbar" id="dropdown-labs">
        <div
          style={styleDropbox}
          className="bt-filter-order"
          role="button"
          data-target="dropdown-labs"
          onClick={() => this.openDropDown()}
        >
          <span className="partner-lab-label" data-target="dropdown-labs">
            {this.state.client.type === "L2L" ? "Laboratório" : "Hospital"}{" "}
            Conveniado
          </span>
          <h1 className="partner-lab-name" data-target="dropdown-labs">
            {this.state.client && this.state.client.name}
          </h1>
        </div>
        <div>
          <PartnerLab />
        </div>

        <ul
          className="dropdown-menu dropdown-menu-default"
          id="dropdown-menu-labs"
          style={{ right: "50px", top: "-10px", minWidth: "0" }}
        >
          {this.state.clientList.map((client) => (
            <li>
              <div
                className={`dropdown-item ${
                  userService.getClientId() === client.code ? "active" : ""
                }`}
                id={client.code}
                style={{ marginRight: "15px" }}
                onClick={() => this.toggleAlterLab(client)}
              >
                <h1 className="partner-lab-name">{client && client.name}</h1>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  changeMenu() {
    this.setState({
      menuOpen: !this.state.menuOpen,
    });
  }

  backToMyPardini(){
    authenticationService.endSession();
    window.location.href = MY_PARDINI_URL;
  }

  render() {
    return (
      <>
        {this.state.loading ? <div id="loader" /> : null}
        <div className="logo-enterprise-digital-tagline">
          Enterprise Digital . Pardini Customer Experience
        </div>
        <div className={`header-nav ${this.state.menuOpen ? "d-flex" : ""}`}>
          <div className="logo-hermes-pardini">Hermes Pardini</div>
          {this.state.clientList.length > 1 ? (
            this.renderDropBox()
          ) : this.state.client &&
            this.state.client.type &&
            this.state.client.type !== "PSC" ? (
            <div className="partner-lab">
              <span className="partner-lab-label">
                {this.state.client.type === "L2L" ? "Laboratório" : "Hospital"}{" "}
                Conveniado
              </span>
              <h1 className="partner-lab-name">
                {this.state.client && this.state.client.name}
              </h1>
            </div>
          ) : null}
        </div>
        <div className="user-menu-container">
          <div className="user-info">
            <span className="user-name">
              {this.state.user && this.state.user.name}
            </span>
            <div className="user-avatar"></div>
          </div>
          <div className="user-menu">
          {userService.checkForMyPardiniSession() ?
          (<div 
            className="user-menu-item"
            onClick={()=> this.backToMyPardini()}
          >
            Voltar ao MyPardini
          </div>): null}
            <div
              className="user-menu-item"
              onClick={(e) => {
                this.logOut(e);
              }}
            >
              Sair
            </div>
          </div>
        </div>
        <div
          className={`ico-menu ${this.state.menuOpen ? "close-menu" : ""}`}
          onClick={() => {
            this.changeMenu();
          }}
        >
          <span></span>
        </div>
      </>
    );
  }
}

export default withRouter(AppBar);
